import { useSelector } from '/druid/internal/WebChatReduxContext';

export default function useSendTypingIndicator(): [boolean] {
  return [useSelector(({ sendTypingIndicator }) => sendTypingIndicator)];
}
